import React from 'react';
import { ACLAuthorizationRequest } from '@/api/bol';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultServiceRequestTemplate } from '@/utils/serviceRequestDefaultTemplate';

export interface ServiceRequestFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; serviceRequestJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const ServiceRequestFormDialog: React.FC<ServiceRequestFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; serviceRequestJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      serviceRequestJson: data.serviceRequestJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations,
    };

    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New ServiceRequest"
      jsonFieldName="serviceRequestJson"
      defaultJsonTemplate={defaultServiceRequestTemplate()}
      jsonLabel="Enter a valid ServiceRequest JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the ServiceRequest schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};
